import { Fragment, useEffect, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { Step, StepLabel, Stepper, Typography } from "@mui/material";
import ComponentFormEtapas from "../../components/Form/Etapas/ComponentFormEtapas";
import UnidadActivaForm from "../../components/Form/UnidadActiva/UnidadActivaForm";
import ChatGPT from "../../components/ChatGPT/ChatGPT";
import PropuestasUnidadActiva from "../../components/Propuestas/PropuestasUnidadActiva";
import { useRespuesta } from "../../data/RespuestaContext";
import { useJobContext } from "../../hooks/Jobs";
import { useProyecto } from "../../data/ProyectoContext";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";

const steps = [
  "¿Qué necesitas planificar?",
  "¡Recibe grandes ideas!",
  "Explora en detalle",
  "Recibe planificación",
];

const UnidadTematicaPage = () => {
  const { etapa, isCompleted, resetState, handleSetTipoEstructuraProyecto } =
    useJobContext();
  const { respuesta } = useRespuesta();
  const [activeStep, setActiveStep] = useState(0);
  const { proyecto, setProyecto } = useProyecto();
  const {
    handleNivelChange,
    handleAsignaturaChangeLocal,
    setPromptData,
    setObjetivosSeleccionados,
  } = useActividadesContext();

  const stepContentMap = [
    <UnidadActivaForm key="unidad_activa_0" />,
    <ComponentFormEtapas
      color="#1AA39B"
      PropuestasComponent={PropuestasUnidadActiva}
      key="unidad_activa_1"
    />,
    <ChatGPT key="unidad_activa_2" respuestaData={respuesta?.propuestas[0]} />,
  ];

  const startUnidadTematica = async () => {
    resetState();
    setProyecto({ ...proyecto, tipo_estructura: "Unidad Activa" });
    setPromptData({});
    await handleNivelChange("", null);
    handleAsignaturaChangeLocal({ id: "", nombre: "" });
    setObjetivosSeleccionados({});
    handleSetTipoEstructuraProyecto("unidad_activa");
  };

  useEffect(() => {
    console.log("cambio en etapa detectado", etapa);
    if (etapa == 0 && !isCompleted) {
      console.log("activando etapa 0");
      setActiveStep(0);
      startUnidadTematica();
    } else {
      setActiveStep(etapa + 1);
    }
  }, [etapa]);

  useEffect(() => {
    console.log(`etapa: ${etapa}`);
    console.log(`activeStep: ${activeStep}`);
    console.log(`isCompleted: ${isCompleted}`);
  }, [etapa, isCompleted, activeStep]);

  return (
    <Fragment>
      <CssBaseline />
      {activeStep > 0 && (
        <Stepper
          alternativeLabel
          activeStep={activeStep}
          sx={{
            "& .MuiStepConnector-line": {
              border: "2px solid #90AFC5",
            },
            m: "auto",
            pt: 5,
            pb: 3,
            width: "80%", // Cambia el color y el grosor de la línea separadora del stepper
            "& .MuiStepIcon-root": {
              color: "#90AFC5", // Color de los pasos no activos
              "&.Mui-completed": {
                color: "#209099", // Color de los pasos completados
              },
              "&.Mui-active": {
                color: "#336B87", // Color del paso activo
              },
            },
          }}
        >
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel>
                <Typography fontFamily="Montserrat" fontSize="0.8rem">
                  {label}
                </Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      )}
      {activeStep === steps.length ? (
        <Typography variant="subtitle1">En construcción...</Typography>
      ) : (
        stepContentMap[activeStep]
      )}
    </Fragment>
  );
};

export default UnidadTematicaPage;
